import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-search-multiple-dialog',
  templateUrl: './search-multiple-dialog.component.html',
  styleUrls: ['./search-multiple-dialog.component.scss']
})
export class SearchMultipleDialogComponent implements OnInit {

  searchBy: string = '';
  searchInput: string = '';
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SearchMultipleDialogComponent>,
  ) { }

  ngOnInit(): void {
    console.log('dialog data ', this.data);
    this.searchBy = this.data.searchBy;
    this.searchInput = this.data.value;
  }


  search(){
    console.log('searchInput:', this.searchInput);
    if (this.searchInput) {
      const parsedInput = this.searchInput
        .split(/[\n;,]+/)  
        .map(input => input.trim())
        .filter(input => input);
      console.log('parsedInputs', parsedInput);
      this.dialogRef.close(parsedInput);
    } else {
      this.dialogRef.close([]);
    }
  }

  close(){
    this.dialogRef.close();
  }

}
